import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowLeft, Plus } from 'lucide-react';
import { Button } from '../components/ui/button';
import MainNav from '../components/MainNav';
import { AIClipsLibrary } from '../components/AIClipsLibrary';

/**
 * MyAIClips
 * ---------
 * Full-page browser for the user's AI generations. Lets them re-use clips in
 * a NEW slideshow (via Create Video → AI Generate → Recent tab) or simply
 * re-download files they previously generated.
 */
export default function MyAIClips() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <MainNav />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white mb-3"
              data-testid="my-ai-clips-back-btn"
            >
              <ArrowLeft className="w-4 h-4" /> Back
            </button>
            <h1 className="text-3xl sm:text-4xl font-bold flex items-center gap-3">
              <Sparkles className="w-8 h-8 text-emerald-400" />
              My AI Clips
            </h1>
            <p className="text-zinc-400 mt-2 text-sm max-w-2xl">
              Every video and image you generate is automatically saved here. Reuse them
              in any slideshow, re-download them anytime, or remove ones you no longer need.
            </p>
          </div>

          <Button
            onClick={() => navigate('/create-video')}
            className="bg-emerald-600 hover:bg-emerald-700 self-start sm:self-auto"
            data-testid="my-ai-clips-create-btn"
          >
            <Plus className="w-4 h-4 mr-1.5" />
            Create new video
          </Button>
        </div>

        {/* Library */}
        <AIClipsLibrary />
      </main>
    </div>
  );
}
